import "./style/RelifeExc.css";
import { NavLink, Link } from "react-router-dom";
import Animation from "../animation/Animation.jsx";
export default function RelifeExc({ contactRef }) {
  return (
    <>
      <section className="feeling-section">
        <div className="feeling-inner">
          <div>
            <div
              className="l-rule"
              style={{ marginLeft: "auto", marginRight: "auto" }}
            />
            <span className="l-eyebrow">A different kind of space</span>
          </div>
          <h2>For the moments when you can't explain what you feel.</h2>
          <p>
            Introspecta helps you slow down, look closer, and understand what
            your answers may be revealing.
          </p>
          <article className="feeling-grid">
            <div className="feeling-card">
              <p className="feeling-card__title">
                When your mind keeps circiling
              </p>
              <p className="feeling-card__text">
                Because something inside you may still be looking for clarity.
              </p>
            </div>
            <div className="feeling-card">
              <p className="feeling-card__title">
                When emotions feel hard to name
              </p>
              <p className="feeling-card__text">
                You may know that something is affecting you before you can
                explain why it has so much power.
              </p>
            </div>
            <div className="feeling-card">
              <p className="feeling-card__title">
                When patterns keep repeating
              </p>
              <p className="feeling-card__text">
                The same reactions often return until you can see what they have
                been trying to show you.
              </p>
            </div>
          </article>
        </div>
      </section>
    </>
  );
}
